/* ============================================================
   LOOP STATION 納期ページ の絞り込み (2026-08-27)
   ------------------------------------------------------------
   日付の計算そのものは delivery_calc.js が持っている。
   ここでは window.LOOP_DELIVERY を借りて「その日までに間に合うか」を判定する。
   ============================================================ */
(function () {
  "use strict";

  var WEEK = ["日", "月", "火", "水", "木", "金", "土"];

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function boot() {
    var grid = document.getElementById("etaGrid");
    if (!grid) return;

    var api = window.LOOP_DELIVERY;
    if (!api) {                       // delivery_calc.js の読み込み待ち
      return setTimeout(boot, 120);
    }

    var byEl = document.getElementById("etaBy"),
        qEl = document.getElementById("etaQ"),
        countEl = document.getElementById("etaCount"),
        emptyEl = document.getElementById("etaEmpty"),
        noteEl = document.getElementById("etaNote"),
        rush = document.getElementById("etaRush"),
        rushLead = document.getElementById("etaRushLead"),
        rushSub = document.getElementById("etaRushSub");
    var cards = [].slice.call(grid.querySelectorAll(".loopeta__card"));
    var origin = "all";

    function fmtW(d) {
      return (d.getMonth() + 1) + "月" + d.getDate() + "日(" + WEEK[d.getDay()] + ")";
    }

    // 各行の出荷予定日を先に出しておく(絞り込みのたびに計算しない)
    cards.forEach(function (c) {
      var cn = c.dataset.origin === "cn";
      [].slice.call(c.querySelectorAll("tbody tr")).forEach(function (tr) {
        var n = parseInt(tr.dataset.days, 10);
        if (!(n >= 0)) return;
        try {
          tr.dataset.ts = api.addBusinessDays(n, cn).date.getTime();
        } catch (e) { /* 計算できない行は絞り込み対象外 */ }
      });
    });

    [].slice.call(document.querySelectorAll(".loopeta__seg button")).forEach(function (b) {
      b.addEventListener("click", function () {
        origin = b.dataset.origin;
        [].slice.call(document.querySelectorAll(".loopeta__seg button")).forEach(function (x) {
          x.setAttribute("aria-pressed", String(x === b));
        });
        apply();
      });
    });
    if (byEl) byEl.addEventListener("change", apply);
    if (qEl) qEl.addEventListener("input", apply);

    function apply() {
      var q = (qEl && qEl.value ? qEl.value : "").trim();
      var by = (byEl && byEl.value) ? new Date(byEl.value + "T00:00:00") : null;
      var shown = 0;

      cards.forEach(function (c) {
        var okQ = !q || (c.dataset.name || "").indexOf(q) >= 0;
        var okO = origin === "all" || c.dataset.origin === origin;
        var okD = true;

        var trs = [].slice.call(c.querySelectorAll("tbody tr"));
        if (by) {
          var any = false;
          trs.forEach(function (tr) {
            tr.classList.remove("is-hit", "is-miss");
            if (!tr.dataset.ts) return;
            if (+tr.dataset.ts <= by.getTime()) {
              tr.classList.add("is-hit");
              any = true;
            } else {
              tr.classList.add("is-miss");
            }
          });
          okD = any;
          if (any && okQ && okO && !c.open) {
            c.open = true;
            c.dataset.autoOpen = "1";   // 自分で開いたぶんだけ後で閉じる
          }
        } else {
          trs.forEach(function (tr) { tr.classList.remove("is-hit", "is-miss"); });
          // 日付の指定を外したら、絞り込みで自動的に開いたぶんは閉じる
          if (c.dataset.autoOpen === "1") {
            c.open = false;
            delete c.dataset.autoOpen;
          }
        }

        var vis = okQ && okO && okD;
        c.hidden = !vis;
        if (vis) shown++;
      });

      if (emptyEl) emptyEl.hidden = shown > 0;

      if (by) {
        var missed = cards.length - shown;
        if (countEl) countEl.textContent = shown + "商品が " + fmtW(by) + " までに出荷できます（緑の行が間に合う数量です）";
        if (noteEl) {
          noteEl.innerHTML = '<span class="loopeta__pill is-ok">間に合う</span>'
            + '<span class="loopeta__pill is-ng">間に合わない</span>'
            + "<span>数量によって出荷日が変わります。緑の行の数量であれば " + fmtW(by) + " までに出荷いたします。</span>";
        }
        if (missed > 0) {
          rush.classList.add("is-alert");
          rushLead.textContent = "間に合わない商品が " + missed + " 件ありますが、あきらめないでください。";
          rushSub.textContent = "ここに出ているのは基本の納期です。数量を分けて先に一部だけお届けする、仕様を一部変えるといった方法で間に合うことがあります。まずはご希望の日をお聞かせください。";
        } else {
          rush.classList.remove("is-alert");
          rushLead.textContent = "表示している日付は、基本の納期です。";
          rushSub.textContent = "さらにお急ぎの場合も、まずはご相談ください。数量や仕様の調整で前倒しできることがあります。";
        }
      } else {
        if (countEl) countEl.textContent = "全 " + shown + " 商品";
        if (noteEl) {
          noteEl.innerHTML = "<span>本日 <strong>" + fmtW(new Date())
            + "</strong> にご注文いただいた場合の出荷予定日を表示しています。</span>";
        }
        rush.classList.remove("is-alert");
        rushLead.textContent = "表示している日付は、基本の納期です。";
        rushSub.textContent = "「この日までに必要」というご事情があれば、まずご相談ください。数量や仕様を調整することで、間に合う場合があります。";
      }
    }

    apply();
  }

  ready(boot);
})();
